export const galleyImageOptions = {
  angle: 'galley',
  staticOptions: {
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    Handrail: 1,
    BerthInfill: 1,
    FabricCabins: 1,
    AftCabinShelving: 1,
    SeaBerths: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Floorboard',
      dependency: 'Layout'
    },
    {
      option: 'Worktop',
      dependency: 'Layout'
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'Handrail',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/galley.js